import { can, canAny } from "src/Common/function";

/**
 * Route-level permission gate. Renders children only when the signed-in user
 * effectively holds the required permission(s) (see can() — deny-wins with
 * wildcards); otherwise shows an access-denied notice instead of the page.
 *
 * Pass `permission` for a single key, or `anyOf` for a set where holding ANY
 * one grants access (e.g. a page with multiple tabs gated by different keys).
 *
 * Usage:
 *   <RequirePermission permission="po:read"><PO /></RequirePermission>
 *   <RequirePermission anyOf={["report:adHocRead", "report:scheduledRead"]}>...</RequirePermission>
 */
function RequirePermission({ permission, anyOf, children }) {
  const allowed = anyOf ? canAny(anyOf) : can(permission);
  if (allowed) return children;

  return (
    <div className="w-full h-full min-h-[400px] flex flex-col items-center justify-center gap-3 bg-backgroundColor">
      <p className="font-OpenSansBold text-[18px] text-titleColor">Access denied</p>
      <p className="font-OpenSansRegular text-[13px] text-subTitleColor text-center max-w-[420px]">
        You don't have permission to view this page. Contact your administrator if you believe this is a mistake.
      </p>
    </div>
  );
}

export default RequirePermission;
